import * as WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: ['Titillium Web:100,200,300,400,600,700,800,900']
  }
});
